import { h } from "preact";
import { RoutableProps } from "preact-router";
import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand } from "../../../hooks";
import { manufacturingConfigurations } from "../../../App";
import { meissaOT } from "../../../data/serialNumberSearchExecs";
import { ProductLabelReprint } from "../../../components/ProductLabelReprint";

export function MeissaOTReprint(props: RoutableProps) {
    const showSnackbar = useCommand<SnackbarShowCommand>();

    return (
        <div class="mezos-sit-reprint-page">
            <Snackbar doShow={showSnackbar} />
            <ProductLabelReprint
                showSnackbar={showSnackbar}
                configurations={manufacturingConfigurations["MeissaOT"]}
                execs={[meissaOT.execs.elementSerialRegexPlain]}
                scanExecs={meissaOT.orderedExecs}
            />
        </div>
    );
}
